import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import lastbus from "../../Assets/lastbus.jpeg";
import "./business.css";

const Business = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="business-container">
                <div className="Business-topic">
                    <h1>Business Consultation</h1>
                </div>
                <div className="def">
                    <span className="def-content">A business consultation service provides expert advice, strategies, and solutions to help businesses improve their operations,
                        increase profitability, and achieve their goals. These services are offered by professional
                        consultants or firms specializing in areas such as marketing, finance, operations, management, and strategy.
                    </span>
                </div>
                <div className="imp" style={{ marginLeft: "4%" }}>
                    <h2 className="question">Why is business consultation important ?</h2>
                    <div className="fullDM-content">
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column" }}>A business consultation service provides expert guidance to help
                            businesses grow, improve efficiency, and stay competitive.
                            <ul className="ul-points">
                                <li className="point">Strategic Growth – Helps businesses develop effective plans for expansion and success.</li>
                                <li className="point">Market Insights – Analyzes market trends and customer behavior to create winning strategies.</li>
                                <li className="point">Operational Efficiency – Optimizes processes, reduces costs, and boosts productivity.</li>
                                <li className="point">Marketing & Branding – Enhances brand identity, digital presence, and customer engagement.</li>
                                <li className="point">Financial Guidance – Assists in budgeting, cash flow management, and investment decisions.</li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "480px" }} className="apps-img" src={lastbus} alt="apps" />
                        </div>
                    </div>
                </div>
                <div className="imp">
                    <h1 className="DM-nextquestion" >Our work as business consultant !</h1>
                    <div className="boxes">
                        <motion.div
                            ref={ref1}
                            initial="hidden"
                            animate={inView1 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0}
                            className="point-box"
                        >
                            <h2 className="point-topic"> Industry & Market Analysis</h2>
                            <span className="point-content">Industry and market analysis helps businesses understand market trends, customer behavior,
                                and competitive landscapes to make informed decisions. It enables businesses to identify opportunities, mitigate risks, and develop effective
                                strategies for growth and sustainability.</span>
                        </motion.div>

                        <motion.div
                            ref={ref2}
                            initial="hidden"
                            animate={inView2 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.3}
                            className="point-box"
                        >
                            <h2 className="point-topic">Management Analysis</h2>
                            <span className="point-content">Management consultation helps businesses enhance efficiency, leadership, and decision-making by optimizing operations and organizational structures.
                                It enables companies to improve productivity, streamline workflows, and achieve long-term success..</span>
                        </motion.div>

                        <motion.div
                            ref={ref3}
                            initial="hidden"
                            animate={inView3 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.6}
                            className="point-box"
                        >
                            <h2 className="point-topic">Business Roadmap</h2>
                            <span className="point-content">A business roadmap is a strategic plan that outlines a company's vision, goals, and the steps needed to achieve them. It provides a clear direction,
                                aligning teams and resources to ensure steady growth and success. By setting milestones, prioritizing tasks, and adapting to market changes, a business roadmap helps
                                organizations stay focused and achieve their long-term objectives efficiently.</span>
                        </motion.div>

                        <motion.div
                            ref={ref4}
                            initial="hidden"
                            animate={inView4 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.9}
                            className="point-box"
                        >
                            <h2 className="point-topic">Competitor Analysis</h2>
                            <span className="point-content">Competitor analysis is the process of identifying and evaluating rival businesses to understand their strengths, weaknesses, and market positioning. It helps businesses assess competitors’ strategies,
                                pricing, customer engagement, and unique selling points. By analyzing this data, companies can refine their own approach,
                                differentiate their offerings, and gain a competitive edge in the market.</span>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Business;